<template>
  <v-layout
    column
    wrap
  >
    <v-flex 
      v-if="componentLoading"
      d-flex
      justify-center
    >
      <v-progress-circular
        :size="64"
        :width="3"
        indeterminate
        color="primary"
      />
    </v-flex>
    <v-flex 
      v-else
    >
      <v-card class="max-shadow">
        <v-layout
          column
          fill-height
          wrap
        >
          <v-flex class="pa-1">
            <v-toolbar
              color="white"
              flat
            >
              <v-btn
                icon
                @click="_navigateBack"
              >
                <v-icon color="iconColor">
                  arrow_back
                </v-icon>
              </v-btn>
              <v-toolbar-title class="blue-grey--text text--darken-3">
                Edit {{ visitorType.general.type_name }}
              </v-toolbar-title>
              <v-spacer />
              <v-toolbar-items>
                <v-btn
                  flat
                  large
                  color="primary"
                  @click.stop="_saveVisitorType"
                >
                  Save
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
          </v-flex>
          <v-tabs
            v-model="activeTab"
            class="px-2"
            color="primary"
            dark
            slider-color="yellow"
            grow
          >
            <v-tab
              v-for="tab in tabs"
              :key="tab.key"
            >
              {{ tab.title }}
            </v-tab>
          </v-tabs>
          <transition
            :enter-active-class="transitionEnterClass"
            :leave-active-class="transitionLeaveClass"
            name="fade"
            mode="out-in"
          >
            <keep-alive>
              <component
                :is="tabs[activeTab].component"
                ref="visitorType"
                :data="visitorType[tabs[activeTab].key]"
                @update="_updateVisitorType(tabs[previousTab].key, $event)"
              />
            </keep-alive>
          </transition>
        </v-layout>
      </v-card>
      <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        :timeout="0"
        bottom
      >
        {{ snackbarMessage }}
        <v-btn
          flat
          @click.native="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>
<script>
import _get from 'lodash/get';
import { database } from '@/firebase';
import pageTransitionMixin from '@/mixins/page-transition-mixin';

import General from './General';
import PhoneScreen from './PhoneScreen';
import HostScreen from './HostScreen';
import CheckinFields from './CheckinFileds';
import Agreement from './Agreement';
import Photo from './Photo';
import IdCardScan from './IdCardScan';
import Badge from './Badge';
import Notifications from './Notifications';

export default {
  name: 'VisitorType',
  components: {
    General,
    PhoneScreen,
    HostScreen,
    CheckinFields,
    Agreement,
    Photo,
    IdCardScan,
    Badge,
    Notifications
  },
  mixins: [pageTransitionMixin],
  props: {
    vtid: {
      type: String,
      default: null,
      required: true
    }
  },
  data() {
    return {
      componentLoading: true,
      visitorType: {},
      activeTab: 0,
      previousTab: 0,
      tabs: [
        { key: 'general', title: 'General', component: General },
        { key: 'phone_screen', title: 'Phone Screen', component: PhoneScreen },
        { key: 'host_screen', title: 'Host Screen', component: HostScreen },
        {
          key: 'checkin_fields',
          title: 'Checkin Fields',
          component: CheckinFields
        },
        { key: 'agreement', title: 'Agreement', component: Agreement },
        { key: 'photo', title: 'Photo', component: Photo },
        { key: 'idCard', title: 'Id Card', component: IdCardScan },
        { key: 'badge', title: 'Badge', component: Badge },
        {
          key: 'notifications',
          title: 'Notifications',
          component: Notifications
        }
      ],
      snackbarMessage: '',
      snackbarColor: 'primary',
      snackbar: false,
      saveData: false
    };
  },
  computed: {
    locationId() {
      return _get(this.$store.state.VMS, 'lid');
    }
  },
  watch: {
    locationId: {
      handler(val) {
        if (val) this.fetchVistorType();
      },
      immediate: true
    },
    activeTab(newVal, oldVal) {
      this.previousTab = oldVal;
    }
  },
  methods: {
    fetchVistorType() {
      const path = `vms/${this.locationId}/settings/checkin_flow/${this.vtid}`;
      database.ref(path).once('value', visitorTypeSnapshot => {
        if (visitorTypeSnapshot) {
          const visitorType = visitorTypeSnapshot.val();
          this.visitorType = visitorType;
          this.componentLoading = false;
        }
      });
    },

    _saveVisitorType() {
      this.activeTab =
        this.activeTab === this.tabs.length - 1 ? 0 : this.activeTab + 1;
      this.saveData = true;
    },

    _navigateBack() {
      this.$router.back();
    },

    _updateVisitorType(key, event) {
      const data = event[0];
      const validation = event[1];
      if (!key || !data) return;

      if (!validation) {
        this.snackbarMessage = 'Invalid Fields has been removed';
        this.snackbarColor = 'error';
        this.snackbar = true;
      }
      this.visitorType[key] = data;
      // We are doing this because when user click on save button, we are changing tab to trigger update event so that the active tab data get's saved
      if (this.saveData) {
        this.saveData = false;
        const path = `vms/${this.locationId}/settings/checkin_flow/${
          this.vtid
        }`;
        console.log(this.locationId, this.visitorType, path);
        database
          .ref(path)
          .update(this.visitorType)
          .catch(error => {
            this.snackbarMessage = error;
            this.snackbarColor = 'error';
            this.snackbar = true;
          });
        this._navigateBack();
      }
    }
  }
};
</script>
